import { Button, Flex, Typography } from 'antd'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { defaultPagination } from 'src/app/shared/components/common/new-table/table.constants'
import { IOuterTableRef } from 'src/app/shared/components/common/new-table/table.model'
import { TableGeneralState } from 'src/app/shared/components/common/table/table.model'

const ActiveQuickFilter: React.FC<{
  props: Partial<TableGeneralState> & {
    loading?: boolean
    isActive?: boolean
    outerTableRef?: React.RefObject<Partial<IOuterTableRef>>
    setIsActive?: React.Dispatch<React.SetStateAction<boolean>>
    handleSearch?: (payload: Partial<any>) => Promise<void>
  }
}> = ({ props }) => {
  const { isActive, setIsActive, handleSearch, loading, outerTableRef, ...etc } = props
  const { t } = useTranslation()

  const handleFilterChange = useCallback(
    (flag: boolean) => {
      setIsActive?.(flag)
      handleSearch?.({ ...etc, pageIndex: defaultPagination, params: { isActive: flag } })
      outerTableRef?.current?.setCurrentPage?.(defaultPagination)
    },
    [etc, handleSearch, outerTableRef, setIsActive],
  )

  return (
    <Flex className='clientSetupQuickFilter' gap={16} align='center'>
      <Typography className='quickView'>{t('ClientSetup:quickView')}</Typography>
      <Button className={`button`} type={isActive ? 'primary' : 'default'} onClick={() => handleFilterChange(true)}>
        {t('ClientSetup:activeClients')}
      </Button>
      <Button className={`button`} type={!isActive ? 'primary' : 'default'} onClick={() => handleFilterChange(false)}>
        {t('ClientSetup:inactiveClients')}
      </Button>
    </Flex>
  )
}

export default ActiveQuickFilter
